
import { call, put, takeEvery } from "redux-saga/effects"
import {
  CREATE_COMPANY,
  DELETE_COMPANY,
  GET_COMPANIES,
  GET_COMPANIES_ALL,
  GET_COMPANY,
  UPDATE_COMPANY,
} from "./actionTypes"
import {
  createCompanySuccess,
  deleteCompanyFail,
  deleteCompanySuccess,
  updateCompanyFail,
  updateCompanySuccess,
  getCompanyFail,
  getCompanySuccess,
  createCompanyFail,
  getCompaniesFail,
  getCompaniesSuccess,
  getCompaniesAllSuccess,
  getCompaniesAllFail,
} from "./actions"

import {
  companies,
  createCompanyData,
  deleteCompanyData,
  getCompanyData,
  updateCompanyData
} from "helpers/backend-helper"

function* getCompanies({ payload }) {
  try {
    const res = yield call(companies, payload)
    yield put(getCompaniesSuccess(res?.data))
  } catch (error) {
    yield put(getCompaniesFail(error?.response?.data?.message || "Something went wrong"))
  }
}

function* getCompaniesAll({ payload }) {
  try {
    const res = yield call(companies, payload)
    yield put(getCompaniesAllSuccess(res?.data))
  } catch (error) {
    yield put(getCompaniesAllFail(error?.response?.data?.message || "Something went wrong"))
  }
}

function* createCompany({ payload: { data, history, getCompanies } }) {
  try {
    const res = yield call(createCompanyData, data)
    yield put(createCompanySuccess(res.message))
    yield put(getCompanies())
    history("/companies")
  } catch (error) {
    yield put(createCompanyFail(error?.response?.data?.message || "Something went wrong"))
  }
}

function* getCompany({ payload: { companyId } }) {
  try {
    const res = yield call(getCompanyData, companyId)
    yield put(getCompanySuccess(res?.data))
  } catch (error) {
    yield put(getCompanyFail(error?.response?.data?.message || "Something went wrong"))
  }
}

function* updateCompany({ payload: { data, history, getCompanies, companyId } }) {
  try {
    const res = yield call(updateCompanyData, { data, companyId })
    yield put(updateCompanySuccess(res.message))
    yield put(getCompanies())
    history("/companies")
  } catch (error) {
    yield put(updateCompanyFail(error?.response?.data?.message || "Something went wrong"))
  }
}

function* deleteCompany({ payload: { history, getCompanies, companyId } }) {
  try {
    const res = yield call(deleteCompanyData, companyId)
    yield put(deleteCompanySuccess(res.message))
    yield put(getCompanies())
    history("/companies")
  } catch (error) {
    yield put(deleteCompanyFail(error?.response?.data?.message || "Something went wrong"))
  }
}

// watcher
export default function* companySaga() {
  yield takeEvery(GET_COMPANIES, getCompanies)
  yield takeEvery(GET_COMPANIES_ALL, getCompaniesAll)
  yield takeEvery(CREATE_COMPANY, createCompany)
  yield takeEvery(GET_COMPANY, getCompany)
  yield takeEvery(UPDATE_COMPANY, updateCompany)
  yield takeEvery(DELETE_COMPANY, deleteCompany)
}
